// Waybills
export const GET_WAYBILLS = "/waybilling/waybills";
export const GET_WAYBILL_FILE = "/waybilling/waybills/getFile";
export const RETRY_WAYBILL = "/waybilling/waybills/retry";
